export const meetings = (state) =>
    state?.meetings?.meetings

export const calendarViewEnabled = (state) =>
  state?.app?.organisationSettings?.useCalendarViewForMeetings